import { render, staticRenderFns } from "./LinkdeConvite_New.vue?vue&type=template&id=5b5b77fa&scoped=true"
import script from "./LinkdeConvite_New.vue?vue&type=script&lang=js"
export * from "./LinkdeConvite_New.vue?vue&type=script&lang=js"
import style0 from "./LinkdeConvite_New.vue?vue&type=style&index=0&id=5b5b77fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5b77fa",
  null
  
)

export default component.exports